import React, { useState } from 'react';
import classnames from 'classnames';

import style from './Playground.module.scss';

export interface PlaygroundProps {
    children: React.ReactNode;
}

export function Playground({ children }: PlaygroundProps) {
    const [isLight, setLightTheme] = useState<boolean>(false);
    return (
        <div className={classnames([style.root, isLight ? style.light : style.dark])}>
            <div
                className={style.switchThemeButton}
                onClick={() => setLightTheme(!isLight)}
            >
                {isLight ? '🌚' : '🌝'}
            </div>
            {children}
        </div>
    );
}
